import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Vant from 'vant';
import 'vant/lib/index.css';
import plugins from '@/utils/plugins';
import { Toast } from 'vant';
import { Dialog } from 'vant';
import { getMobileToken, wxConfig, wxlogin } from '@/api/base';
import { getParams, getWxAuthParams, clearLocationSearch } from '@/utils/index';
import MetaInfo from 'vue-meta-info';

import plateList from './utils/plateList';
window.localStorage.setItem('plateList', JSON.stringify(plateList));
Vue.use(MetaInfo);
Vue.use(plugins);
Vue.use(Vant);
Vue.use(Toast);
Vue.use(Dialog);
Vue.config.productionTip = false;
// common.css
import '@/assets/css/common.css';
import 'amfe-flexible'; //引入rem自适应
// 防止 beforeEach 多次触发时并发发起多次微信授权，导致 /weoauth/oauthInfo 被重复调用
let isAuthorizing = false;
router.beforeEach((to, from, next) => {
  console.log(to, from);
  if (from.query.icoi) {
    to.query.icoi = from.query.icoi;
  }
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // document.documentElement.scrollTop = 0;
  // 兼容读取授权回调参数：location.search（# 前）/ hash 中 ? 后 query / route.query
  const authParams = getWxAuthParams(to.query);

  if (authParams.openId && authParams.nickName) {
    window.localStorage.setItem('userInfo', JSON.stringify(authParams));
  }
  if (authParams.openId) {
    window.localStorage.setItem('openId', authParams.openId);
  }
  if (authParams.sessionKey) {
    window.localStorage.setItem('sessionKey', authParams.sessionKey);
  }
  // 持久化其余业务参数（存在才写）
  ['unionId', 'subscribe', 'isReceive', 'isReceiveFt', 'isReceiveActivity'].forEach(k => {
    if (authParams[k] !== undefined && authParams[k] !== null && authParams[k] !== '') {
      window.localStorage.setItem(k, authParams[k]);
    }
  });

  let openId = window.localStorage.getItem('openId');
  let sessionKey = window.localStorage.getItem('sessionKey');
  window.openId = openId;

  // 清理 URL 上的敏感参数，避免分享泄露/刷新重复处理（仅在带授权参数时才清理）。
  // 注意：检测来源必须用「清理后会变空」的值，否则会与跳转互相触发导致死循环。
  // - # 前 search：vue-router 不管理，用 replaceState 同步剥离（剥离后 location.search 即为空）。
  // - # 后 hash query：由 vue-router 管理，用 to.query 判断（重定向后 to.query 不再含授权 key）。
  const AUTH_KEYS = [
    'openId',
    'sessionKey',
    'unionId',
    'nickName',
    'subscribe',
    'isReceive',
    'isReceiveFt',
    'isReceiveActivity',
  ];
  const searchHasAuth = AUTH_KEYS.some(k => new URLSearchParams(window.location.search).has(k));
  if (searchHasAuth) {
    clearLocationSearch(); // 同步去掉 # 前的 search（Windows 微信回调参数在此）
  }
  if (AUTH_KEYS.some(k => to.query[k] !== undefined)) {
    // 临时折扣 token 属于扫码业务参数，微信授权完成后仍需保留用于后续校验。
    const businessQuery = to.query.discountToken ? { discountToken: to.query.discountToken } : {};
    next({ path: to.path, query: businessQuery, replace: true }); // 重定向到无授权参数的干净路由
    return;
  }

  if (to.path == '/posts' || to.path == '/coin') {
    next();
  } else if (
    (!openId && to.path.indexOf('login') == '-1') ||
    (!sessionKey &&
      to.path.indexOf('login') == '-1' &&
      authParams.subscribe &&
      authParams.subscribe === 'true')
  ) {
    if (isAuthorizing) return; // 已在授权流程中，避免重复跳转
    isAuthorizing = true;
    let href = encodeURIComponent(window.location.href);
    // next(`/login?backUrl=${href}`)
    wxlogin({ backUrl: href }).then(res => {
      window.location.href = res.data;
    });
  }
  // else if(to.query && to.query.subscribe && to.query.subscribe==="false"){
  //   Dialog.alert({
  //     message: '您尚未关注公众号,请先关注公众号！！！',
  //     confirmButtonText	:'去关注'
  //   }).then(() => {
  //     // on clos
  //     window.location.href="https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg3MTczOTQxMw==#wechat_redirect"
  //   });
  // }
  else {
    next();
  }
});
const u = navigator.userAgent;
const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const el = isiOS ? document.documentElement : document.body;
// 页面滚动到指定位置
router.afterEach((to, from) => {
  console.log(to);
  console.log(from);
  // if (to.meta.keepAlive && to.meta.scrollHeight && from.path!='/plate') {
  //   setTimeout(() => {
  //     console.log(window)
  //     console.log(to.meta.scrollHeight)
  //     el.scrollTop = to.meta.scrollHeight
  //   }, 80)
  // } else {
  //   // Vue.nextTick(() => {
  //   //   el.scrollTop = 0
  //   // })
  // }
});
// 首次进入时若本地无 token，则在后台获取 extra_user_token。
// 页面不能等待该请求完成后再挂载，否则微信 WebView 冷启动或弱网时会一直白屏。
function ensureMobileToken() {
  const cachedToken = window.localStorage.getItem('extra_user_token');
  if (cachedToken) {
    window.extra_user_token = cachedToken;
    return Promise.resolve();
  }
  return getMobileToken(getParams())
    .then(res => {
      window.localStorage.setItem('extra_user_token', res.token);
      window.extra_user_token = res.token;
    })
    .catch(error => {
      // 获取 token 失败不阻塞页面，后续 401 仍由响应拦截器透明刷新重试
      console.warn('初始化移动端 token 失败，页面将继续加载', error);
    });
}

// 微信 JS-SDK 属于增强能力，初始化失败时不能影响 Vue 页面渲染。
function initializeWechatSdk(signUrl) {
  const wechat = window.wx;
  if (!wechat) {
    console.warn('微信 JS-SDK 加载失败，已跳过微信分享初始化');
    return Promise.resolve();
  }

  // 先注册默认分享回调，详情页随后注册的回调会在 ready 后覆盖默认值。
  // 即使签名接口尚未返回，微信 SDK 也会暂存 ready 回调，不会提前执行分享 API。
  wechat.ready(function() {
    wechat.updateAppMessageShareData({
      title: '一尘盯盘助手', // 分享标题
      desc: '一尘网查价、盯盘自动提醒，捡漏快人一步！', // 分享描述
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
      success: function() {
        // 设置成功
      },
    });
    wechat.updateTimelineShareData({
      title: '一尘盯盘助手', // 分享标题
      desc: '一尘网查价、盯盘自动提醒，捡漏快人一步！', // 分享描述
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标  //https://ycawxmp.oss-cn-beijing.aliyuncs.com/icon.jpg
      success: function() {
        // 设置成功
      },
    });
    wechat.onMenuShareAppMessage({
      title: '一尘盯盘助手', // 分享标题
      desc: '一尘网查价、盯盘自动提醒，捡漏快人一步！', // 分享描述
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
      success: function() {
        // 用户点击了分享后执行的回调函数
      },
    });
    wechat.onMenuShareTimeline({
      title: '一尘盯盘助手', // 分享标题
      link: 'https://ui.smartrecorder.xyz/#/plate', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: 'https://ui.smartrecorder.xyz/image/ycIcon.jpg', // 分享图标
      success: function() {
        // 用户点击了分享后执行的回调函数
      },
    });
  });

  if (typeof wechat.error === 'function') {
    wechat.error(error => {
      console.warn('微信 JS-SDK 配置失败，页面功能不受影响', error);
    });
  }

  return wxConfig({ url: signUrl })
    .then(res => {
      wechat.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.data.appId, // 必填，公众号的唯一标识
        timestamp: res.data.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
        signature: res.data.signature, // 必填，签名
        jsApiList: [
          'onMenuShareAppMessage',
          'onMenuShareTimeline',
          'chooseWXPay',
          'showOptionMenu',
          'updateAppMessageShareData',
          'updateTimelineShareData',
          'hideMenuItems',
          'showMenuItems',
          'chooseImage',
          'uploadImage',
        ], // 必填，需要使用的JS接口列表
        openTagList: ['wx-open-launch-weapp'],
      });
    })
    .catch(error => {
      console.warn('获取微信 JS-SDK 配置失败，页面功能不受影响', error);
    });
}

// 在路由清理授权参数之前保留进入微信时的原始 URL，确保 iOS 微信签名地址不被改写。
const initialWechatUrl = window.location.href;

// token 与微信配置先并发发起，但 Vue 不等待它们完成。
ensureMobileToken();
initializeWechatSdk(initialWechatUrl);

// 立即挂载 Vue，确保任何初始化接口失败时用户仍能看到页面，而不是空白的 #app。
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
